function toggleSideNav(event) {
    event.preventDefault();

    var sidenav = event.target.closest('.js-sidenav');
    if (!sidenav) return;

    var isOpen = sidenav.classList.contains('is-open');

    if (isOpen) {
        sidenav.classList.remove('is-open');
        sidenav.setAttribute('aria-expanded', 'false');
    } else {
        sidenav.classList.add('is-open');
        sidenav.setAttribute('aria-expanded', 'true');
    }
}

function applySideNavClicks() {
    document.querySelectorAll('.js-sidenav-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function (event) {
            toggleSideNav(event);
        }, false);
    });
}

applySideNavClicks();
